import React, { useRef, useState, Suspense } from "react";
import { FaSpinner  } from "react-icons/fa";
import axios from 'axios';
import { Text, Img, Button, Input, Footer, Heading, HomepageColumnclockhist } from "../../components";
import { IoMdLogIn } from "react-icons/io";
import validate from '../../utils/validate';

const data = [
  {
    extraordinary: "75% de los docentes",
    aphraseisa: "declaran no tener suficiente tiempo para preparar material para sus clases.",
  },
  {
    extraordinary: "Los profesores saben qué material necesitan sus alumnos",
    aphraseisa: "pero necesitan encontrarlo rápido y con la calidad esperada.",
  },
  {
    extraordinary: "Los profesores necesitan materiales de diferente nivel de profundidad.",
    aphraseisa: "Por eso nuestros recursos son generados con diferentes niveles de desafío.",
  },
];

export default function HomepagePage() {
  const labelInscribemeRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);

  const iconLoading = <FaSpinner className="loading-icon" size="20" />

  const initialState = {
    nombre: '',
    cargo: '',
    colegio: '',
    ciudad: '',
    email: '',
    telefono: ''
  };

  const [formData, setFormData] = useState(initialState);

  const rules = {
    nombre: 'required|string',
    cargo: 'required|string',
    colegio: 'required|string',
    ciudad: 'required|string',
    email: 'required|email',
    telefono: 'required|string'
  };
  

  const handleChange = (e) => {
    if (e.target) { 
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    setIsLoadingLogin(true);
    const redirect = `${process.env.REACT_APP_COGNITO_URL}/login?client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&response_type=code&scope=${process.env.REACT_APP_COGNITO_SCOPE}&redirect_uri=${encodeURIComponent(process.env.REACT_APP_COGNITO_REDIRECT_URL)}`;
    window.location.href = redirect;
  };

  const handleWhatsapp = async (e) => {
    e.preventDefault();
    const redirect = `https://api.whatsapp.com/send/?phone=${process.env.REACT_APP_PHONE_WHATSAPP}&text=${process.env.REACT_APP_MSG_WHATSAPP}`;
    window.open(redirect, '_blank');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await validate.rules(formData, rules)
    .then(async () => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_URL_BACKEND}/portal/landing/setcontacto`, formData);
        if (response.data.status === false) {
          throw new Error(response.data.message);
        }
        setIsSubmitted(true);
        setFormData(initialState);
        setErrors({});
        setIsLoading(false);
        setTimeout(() => setIsSubmitted(false), 5000);
      } catch (error) {
        console.error('Error al enviar formulario', error);
      }
    })
    .catch((errorObjects) => {
      setIsLoading(false);
      const formattedErrors = {};
      errorObjects.forEach(error => {
        formattedErrors[error.field] = error.message;
      });
      setErrors(formattedErrors);
    });
  };

  const scrollToSecondButton = () => {
    if (labelInscribemeRef.current) {
      labelInscribemeRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  const [isShown, setIsShown] = useState(false);
  const handleClick = event => {
    console.log("shown");
    setIsShown(current => !current);

    //setIsShown(true);
  };
  return (
    <>
      <div className="wrapper-video" style={{display: isShown ? 'block' : 'none'}}>
        <div className="wrapper-fondo" onClick={handleClick}>
          <div className="div-block-11">
            <div className="w-video w-embed">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/3FBvsoDYgxQ?rel=0" title="Brincus School: Profesores + IA = Super Profes" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe></div>
          </div>
        </div>
      </div>
      <div className="w-full bg-white-A700 max-w-[1550px] m-auto">
          <header className="flex items-center justify-between gap-5 self-end w-full max-w-[1440px] absolute pt-6 px-8 sm:px-4">
            <Img
              src="images/img_header_logo.svg"
              alt="headerlogo"
              className="max-h-[40px] h-auto w-[231px] sm:w-[150px] object-contain"
            />
            <Button
              leftIcon={
                <Img src="images/img_arrowrightshort.svg" alt="arrow-right-short" className="h-[20px] w-[20px]" />
              }
              className="flex h-[48px] sm:h-[38px] border border-solid border-indigo-A200 flex-row items-center justify-center gap-2 rounded-lg text-center font-inter text-base font-medium"
              size="lg"
              color="white_A700"
              onClick={handleSubmitLogin}
              rightIcon={isLoadingLogin && iconLoading}
              {...(isLoadingLogin && { disabled: true })}
            >
              Iniciar sesión
            </Button>
          </header>
          <div className="flex items-start gap-8 bg-white-A700 md:flex-col">
            <div className="flex w-[47%] flex-col gap-[98px] md:w-full lg:gap-[73px] sm:gap-[49px]">
              <div className="flex flex-col xxl:pl-8 sm:pl-2">
                <div className="mt-[120px] flex flex-col items-start gap-[11px]">
                  <Heading
                    size="heading2xl"
                    as="h1"
                    className="w-full !font-inter text-[50px] font-extrabold leading-[60px] tracking-[-1.00px] !text-indigo-A200 md:text-[46px] sm:text-[40px]"
                  >
                    <span className="text-gray-900">Inteligencia artificial + profes&nbsp;</span>
                    <span className="text-gray-900">=</span>
                    <span className="text-gray-900">
                      <>
                        &nbsp;
                        <br />
                      </>
                    </span>
                    <span className="text-indigo-A200">Súper Profes</span>
                  </Heading>
                  <Text as="p" className="text-base font-normal !text-gray-900">
                    Construye el mejor material para tus clases de forma simple y muy rápida.
                  </Text>
                </div>
                <div className="mt-[33px] flex w-[370px] justify-start gap-5">
                  <Button
                    className="font-nunito inline-flex cursor-pointer h-auto leading-[normal] py-3 px-4 text-[17px] sm:text-[14px] text-center justify-center rounded-lg w-[130px]"
                    color="indigo_A200"
                    size="sm"
                    variant="fill"
                    onClick={handleClick}
                    leftIcon={<Img src="images/img_camera_video.svg" alt="cameravideo" className="h-[20px] w-[20px]" />}
                  >
                    Ver video
                  </Button>
                  <Button
                    className="font-nunito inline-flex cursor-pointer h-auto leading-[normal] py-3 px-6 text-[17px] sm:text-[14px] text-center justify-center rounded-lg border border-solid border-indigo-A200 w-[225px]"
                    color="white_A700"
                    size="sm"
                    variant="fill"
                    onClick={handleWhatsapp}
                    leftIcon={<Img src="images/img_vector_ws.svg" alt="vector" className="h-[20px] w-[20px]" />}
                  >
                    Hablemos de esto
                  </Button>
                </div>
              </div>
              <div className="flex flex-col items-start py-2 ml-7 sm:ml-2">
                <div className="mt-[17px] flex w-[370px] items-center justify-center gap-2 rounded-[22px] border border-solid border-blue_gray-200 p-2">
                  <div className="flex flex-1 flex-wrap justify-center items-center gap-2">
                    <Heading size="headingxs" className="text-xs font-black !text-indigo-A200">
                      +100K
                    </Heading>
                    <span className="!font-nunitosans text-xs font-normal !text-gray-900">
                      profesores y contando
                    </span>
                  </div>
                  <div className="flex w-[35%] justify-center">
                    <div className="flex w-full flex-col items-center rounded-[14px] border border-solid border-teal-A700 p-0.5">
                      <Img
                        src="images/img_avatar.png"
                        alt="avatar"
                        className="h-[25px] w-[25px] rounded-[12px] object-cover"
                      />
                    </div>
                    <div className="flex w-full flex-col items-center rounded-[14px] border border-solid border-amber-500 p-0.5">
                      <Img
                        src="images/img_avatar_25x25.png"
                        alt="avatar"
                        className="h-[25px] w-[25px] rounded-[12px] object-cover"
                      />
                    </div>
                    <div className="flex w-full flex-col items-center rounded-[14px] border border-solid border-indigo-A200 p-0.5">
                      <Img
                        src="images/img_avatar_1.png"
                        alt="avatar"
                        className="h-[25px] w-[25px] rounded-[12px] object-cover"
                      />
                    </div>
                  </div>
                </div>
                <Heading
                  size="headingxs"
                  as="h3"
                  className="mt-[15px] !font-inter text-xs font-bold uppercase !text-gray-600"
                >
                  Reconocimientos otorgados en Latinoamérica
                </Heading>
                <div className="flex items-center sm:gap-0 gap-[31px] self-stretch mt-6">
                  <div className="w-full sm:p-0 md:p-5">
                    <Img
                      src="images/img_start_up_chile_logo.png"
                      alt="image"
                      className="sm:m-0 m-auto h-auto w-full object-cover"
                    />
                  </div>
                  <div className="w-full sm:p-0 md:p-5">
                    <Img 
                      src="images/img_images_2_1.png" 
                      alt="images2one" 
                      className="sm:m-0 m-auto h-auto w-full object-cover" 
                    />
                  </div>
                  <div className="w-full sm:p-0 md:p-5">
                    <Img
                      src="images/img_disc_a_png_1.png"
                      alt="discapngone"
                      className="sm:m-0 m-auto h-auto w-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="h-auto sm:max-h-[500px] flex-1 self-start bg-[url(/public/images/img_dise_o.png)] bg-cover bg-no-repeat md:self-stretch md:px-5 sm:px-2">
              <div className="rounded-tx-[16px] pt-[180px] md:pt-[140px] sm:pt-[50px] items-end w-full xxl:max-w-[550px] lg:max-w-[500px] md:max-w-[500px] sm:max-w-[370px] min-h-[750px] m-auto justify-end">
                <Img
                  src="images/img_wtmpztgjebu.png"
                  alt="wtmpztgjebu"
                  className="h-auto w-full rounded-tx-[16px] object-cover m-auto"
                />
              </div>
            </div>
          </div>
          <div className="shadow-bs2 w-full h-2"></div>
          <div className="pb-[30px] sm:pb-5">
            <div className="flex flex-col items-center bg-white-A700 py-12 md:py-5">
              <div className="container-xs flex flex-col items-center gap-8 px-32 md:p-5 md:px-5">
                <Heading
                  size="headinglg"
                  as="h2"
                  className="w-[78%] text-center !font-inter text-[32px] font-extrabold leading-[38px] !text-gray-900 md:w-full md:text-3xl sm:text-[28px]"
                >
                  Somos profesores, sabemos que no tienes tiempo y queremos ayudarte
                </Heading>
                <div className="flex gap-10 sm:gap-4 self-stretch md:flex-col md:px-5">
                  <Suspense fallback={<div>Loading feed...</div>}>
                    {data.map((d, index) => (
                      <HomepageColumnclockhist {...d} key={"listclockhistor" + index} />
                    ))}
                  </Suspense>
                </div>
              </div>
            </div>
          </div>
          <div className="shadow-bs2 w-full h-2"></div>
          <div className="flex flex-col items-center bg-white-A700 px-12 sm:px-5 py-12 md:py-5">
            <div className="container-xs flex flex-col gap-12">
              <div className="flex items-center gap-8 md:flex-col w-full m-auto">
                <div className="flex w-[48%] flex-col gap-8 md:w-full">
                  <Heading
                    size="headinglg"
                    as="h2"
                    className="!font-inter text-[32px] font-extrabold leading-[38px] !text-gray-900 md:text-3xl sm:text-[28px]"
                  >
                    Ahorra hasta un 90% de tiempo en la elaboración de guías de trabajo.
                  </Heading>
                  <div className="flex flex-col gap-4">
                    <Text
                      size="textlg"
                      as="p"
                      className="!font-nunitosans text-[21px] font-normal leading-7 !text-gray-900"
                    >
                      Edita y controla todo el contenido en linea y obtén tus archivos en formatos complemente editables
                    </Text>
                    <Text
                      size="textlg"
                      as="p"
                      className="!font-nunitosans text-[21px] font-normal leading-7 !text-gray-900"
                    >
                      Recibe tu guía perfectamente diagramada y con la insignia de tu colegio en 4 minutos.
                    </Text>
                    <div className="flex flex-col items-start gap-1.5">
                      <Heading size="headingxs" as="h3" className="text-xs font-bold !text-blue_gray-200">
                        Archivos editables y compatibles con:{" "}
                      </Heading>
                      <div className="flex gap-4">
                        <Button className="flex h-[69px] w-[72px] items-center justify-center rounded-lg border border-solid border-blue_gray-200 p-4">
                          <Img src="images/img_frame_3720.png" />
                        </Button>
                        <Button className="flex h-[69px] w-[72px] items-center justify-center rounded-lg border border-solid border-blue_gray-200 p-4">
                          <Img src="images/img_frame_3721.png" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-1 justify-center p-4 sm:p-0 md:self-stretch">
                  <Img
                    src="images/img_img_preguntas.png"
                    alt="imgpreguntas"
                    className="h-auto w-full max-w-[600px] object-cover"
                  />
                </div>
              </div>
              <div className="flex items-center gap-8 md:flex-col">
                <div className="flex flex-1 md:self-stretch items-center justify-center w-full">
                  <Img
                    src="images/img_preguntas.svg"
                    alt="imgpreguntas"
                    className="h-auto w-full max-w-[400px] object-cover"
                  />
                </div>
                <div className="flex w-full max-w-[650px] flex-col gap-8 justify-start items-start">
                  <Heading
                    size="headinglg"
                    as="h4"
                    className="!font-inter text-[32px] font-extrabold leading-[38px] !text-gray-900 md:text-3xl sm:text-[28px]"
                  >
                    Inteligencia artificial entrenada con un modelo pedagógico robusto.
                  </Heading>
                  <div className="flex justify-start items-start gap-4 md:flex-col">
                    <Img src="images/img_bandera.svg" alt="bandera" className="h-[32px] w-[32px]" />
                    <Text
                      size="textlg"
                      as="p"
                      className="w-[94%] !font-nunitosans text-[21px] font-normal leading-7 !text-gray-700 md:w-full"
                    >
                      Todo el contenido curricular del MINEDUC ordenado por objetivos de aprendizaje.
                    </Text>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="shadow-bs2 w-full h-2"></div>
          <div className="flex flex-col items-center bg-white-A700 py-12 md:py-5">
            <div className="flex flex-col gap-6 md:p-5 w-full px-[80px]">
              <div className="flex flex-col items-center gap-[5px]">
                <Heading
                  size="headingxl"
                  as="h2"
                  className="!font-inter text-4xl font-extrabold !text-gray-900 md:text-[34px] sm:text-[32px]"
                >
                  Encuentra distintos tipos de material educativos
                </Heading>
                <Text size="textlg" as="p" className="!font-nunitosans text-[21px] font-normal !text-blue_gray-700">
                  Aquí encontrarás el documento ideal para complementar tus clases
                </Text>
              </div>
              <div className="flex gap-8 md:flex-col md:px-24 sm:px-0">
                <div
                  className={`flex h-auto min-h-[400px] w-full flex-col items-start justify-end gap-[3px] rounded-lg bg-cover bg-no-repeat md:h-auto self-start bg-[url(/public/images/img_card.png)] md:self-stretch`}
                >
                  <Text
                    as="p"
                    className="ml-7 mt-[292px] flex items-center justify-center rounded-lg bg-indigo-A200 text-white-A700 px-4 py-0.5 text-base font-normal md:ml-4"
                  >
                    Creador de
                  </Text>
                  <div className="w-full min-h-[100px] bg-gradient-to-b from-black-900_1e to-black-900_3f">
                    <Heading
                      size="headingmd"
                      as="h3"
                      className="ml-7 !font-inter text-2xl font-bold !text-white-A700 md:ml-4 md:text-[22px] mt-[20px] text-shadow"
                    >
                      Guías de ejercicios
                    </Heading>
                  </div>
                </div>
                <div
                  className={`flex h-auto min-h-[400px] w-full flex-col items-start justify-end gap-[3px] rounded-lg bg-cover bg-no-repeat md:h-auto self-start bg-[url(/public/images/img_card_400x405.png)] md:self-stretch`}
                >
                  <Text
                    as="p"
                    className="ml-7 mt-[292px] flex items-center justify-center rounded-lg bg-pink-300 text-white-A700 px-4 py-0.5 text-base font-normal md:ml-4"
                  >
                    Creador de
                  </Text>
                  <div className="w-full min-h-[100px] bg-gradient-to-b from-black-900_1e to-black-900_3f">
                    <Heading
                      size="headingmd"
                      as="h3"
                      className="ml-7 !font-inter text-2xl font-bold !text-white-A700 md:ml-4 md:text-[22px] mt-[20px] text-shadow"
                    >
                      Presentaciones
                    </Heading>
                  </div>
                </div>
                <div
                  className={`flex h-auto min-h-[400px] w-full flex-col items-start justify-end gap-[3px] rounded-lg bg-cover bg-no-repeat md:h-auto self-start bg-[url(/public/images/img_card_1.png)] md:self-stretch`}
                >
                  <Text
                    as="p"
                    className="ml-7 mt-[292px] flex items-center justify-center rounded-lg bg-teal-A700 text-white-A700 px-4 py-0.5 text-base font-normal md:ml-4"
                  >
                    Creador de
                  </Text>
                  <div className="w-full min-h-[100px] bg-gradient-to-b from-black-900_1e to-black-900_3f">
                    <Heading
                      size="headingmd"
                      as="h3"
                      className="ml-7 !font-inter text-2xl font-bold !text-white-A700 md:ml-4 md:text-[22px] mt-[20px] text-shadow"
                    >
                      Actividades
                    </Heading>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-8 bg-white-A700 p-8 md:flex-col sm:p-5">
            <div className="flex w-[41%] flex-col items-start gap-8 md:w-full">
              <Heading
                size="headinglg"
                as="h2"
                className="!font-inter text-[32px] font-extrabold !text-gray-900 md:text-3xl sm:text-[28px]"
              >
                Solicita una DEMO o reunión
              </Heading>
              <Text
                size="textlg"
                as="p"
                className="w-full !font-nunitosans text-[21px] font-normal leading-7 !text-gray-900"
              >
                <span className="text-gray-800">
                  <>
                    Nos encantaría mostrarte cómo nuestra plataforma de Inteligencia Artificial puede ser una tremenda
                    herramienta para tu colegio; apoyando a los profesores a optimizar su tiempo en creación de material
                    y entregando diversos recursos educativos para mejorar los niveles de aprendizaje de tus
                    estudiantes.
                    <br />
                    <br />
                  </>
                </span>
                <span className="font-nunito font-extrabold text-gray-800">
                  Déjanos tus datos en el formulario y te contactaremos...
                </span>
              </Text>
            </div>
            <div className="my-4 flex-1 rounded-lg bg-gray-600 p-6 md:self-stretch md:p-5">
              <form onSubmit={handleSubmit}>
                <div className="grid sm:grid-cols-1 grid-cols-2 gap-2 items-start w-full">
                  <div className="items-start justify-start p-3">
                    <Text
                      className="text-base text-white-A700 w-auto"
                      size="txtInterBold16"
                    >
                      Nombre
                    </Text>
                    <Input
                      name="nombre"
                      required
                      value={formData.nombre}
                      onChange={handleChange}
                      placeholder="Ingresa tu nombre completo"
                      className="font-nunito leading-[normal] p-0 placeholder:text-blue_gray-200_01 text-base text-left w-full"
                      wrapClassName="border border-gray-300_01 border-solid w-full"
                      shape="round"
                    ></Input>
                    {errors.nombre && <p className="error-message text-white-A700">{errors.nombre}</p>}
                  </div>
                  <div className="items-start justify-start p-3">
                    <Text
                      className="text-base text-white-A700 w-auto"
                      size="txtInterBold16"
                    >
                      Cargo
                    </Text>
                    <Input
                      name="cargo"
                      required
                      value={formData.cargo}
                      onChange={handleChange}
                      placeholder="Cargo en la empresa"
                      className="font-nunito leading-[normal] p-0 placeholder:text-blue_gray-200_01 text-base text-left w-full"
                      wrapClassName="border border-gray-300_01 border-solid w-full"
                      shape="round"
                    ></Input>
                    {errors.cargo && <p className="error-message text-white-A700">{errors.cargo}</p>}
                  </div>
                </div>
                <div className="grid sm:grid-cols-1 grid-cols-2 gap-2 items-start justify-between w-full">
                  <div className="items-start justify-start p-3">
                    <Text
                      className="text-base text-white-A700 w-auto"
                      size="txtInterBold16"
                    >
                      Colegio
                    </Text>
                    <Input
                      name="colegio"
                      required
                      value={formData.colegio}
                      onChange={handleChange}
                      placeholder="Ingresa tu establecimiento"
                      className="font-nunito leading-[normal] p-0 placeholder:text-blue_gray-200_01 text-base text-left w-full"
                      wrapClassName="border border-gray-300_01 border-solid w-full"
                      shape="round"
                    ></Input>
                    {errors.colegio && <p className="error-message text-white-A700">{errors.colegio}</p>}
                  </div>
                  <div className="items-start justify-start p-3">
                    <Text
                      className="text-base text-white-A700 w-auto"
                      size="txtInterBold16"
                    >
                      Ciudad
                    </Text>
                    <Input
                      name="ciudad"
                      required
                      value={formData.ciudad}
                      onChange={handleChange}
                      placeholder="Ingresa tu ciudad"
                      className="font-nunito leading-[normal] p-0 placeholder:text-blue_gray-200_01 text-base text-left w-full"
                      wrapClassName="border border-gray-300_01 border-solid w-full"
                      type="ciudad"
                      shape="round"
                    ></Input>
                    {errors.ciudad && <p className="error-message text-white-A700">{errors.ciudad}</p>}
                  </div>
                </div>
                <div className="grid sm:grid-cols-1 grid-cols-2 gap-2 items-start justify-between w-full">
                  <div className="items-start justify-start p-3">
                    <Text
                      className="text-base text-white-A700 w-auto"
                      size="txtInterBold16"
                    >
                      Correo Electrónico
                    </Text>
                    <Input
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Tucorreo@gmail.com"
                      className="font-nunito leading-[normal] p-0 placeholder:text-blue_gray-200_01 text-base text-left w-full"
                      wrapClassName="border border-gray-300_01 border-solid w-full"
                      type="email"
                      shape="round"
                    ></Input>
                    {errors.email && <p className="error-message text-white-A700">{errors.email}</p>}
                  </div>
                  <div className="items-start justify-start p-3">
                    <Text
                      className="text-base text-white-A700 w-auto"
                      size="txtInterBold16"
                    >
                      Teléfono
                    </Text>
                    <Input
                      name="telefono"
                      required
                      value={formData.telefono}
                      onChange={handleChange}
                      placeholder="(+569) 8123 4567"
                      className="font-nunito leading-[normal] p-0 placeholder:text-blue_gray-200_01 text-base text-left w-full"
                      wrapClassName="border border-gray-300_01 border-solid w-full"
                      shape="round"
                    ></Input>
                    {errors.telefono && <p className="error-message text-white-A700">{errors.telefono}</p>}
                  </div>
                </div>
                <div className="grid sm:grid-cols-1 grid-cols-2 gap-2 items-start justify-between w-full">
                  <div className="items-start justify-start p-3">
                    <Button
                      className="font-nunito inline-flex cursor-pointer h-auto leading-[normal] p-5 w-full text-[17px] text-center justify-center rounded-lg"
                      color="indigo_A200"
                      size="md"
                      variant="fill"
                      onClick={handleSubmit}
                      leftIcon={<Img src="images/img_clipboardcheck.svg" alt="vector" className="h-[20px] w-[20px]" />}
                      rightIcon={isLoading && iconLoading}
                      {...(isLoading && { disabled: true })}
                    >
                      Inscribirme para DEMO
                    </Button>
                  </div>
                  <div className="items-start justify-start p-3">
                    <Button
                      className="font-nunito inline-flex cursor-pointer h-auto leading-[normal] text-[17px] text-center justify-center rounded-lg border border-solid border-gray-100 w-full hover:bg-gray-900"
                      color="transparent"
                      size="lg"
                      variant="fill"
                      onClick={handleWhatsapp}
                      leftIcon={<Img src="images/img_vector_gray_100.svg" alt="vector" className="h-[20px] w-[20px]" />}
                    >
                      Hablemos de esto
                    </Button>
                  </div>
                </div>
              </form>
              {isSubmitted && (
                <div className="bg-green-500 border-green-700 text-white-A700 p-2 my-1 rounded">
                  <i className=""></i> Formulario guardado correctamente
                </div>
              )}
            </div>
          </div>
      </div>
      <Footer />
    </>
  );
}
